module.exports = __webpack_public_path__ + "static/topup-history-2fa7da9d762fc0334c42081a471ab70d.png";